import React from 'react';
import './AllSelectedHandList.css'
import HandListSingleRow from './HandListSingleRow';

class AllSelectedHandList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            accountName: localStorage.getItem('accountName'),
        }
    }

    render() {
        return (
            <div>
                <div className="centerModal MultiReplayer_centerModal">
                    <div className={`seeMoreAllInHands seeMoreAllInHands_multiReplayer ${this.props.replayerScreen === 'shared' ? "seeMoreAllInHands_multiReplayer_shared" : ""}`}>
                        <div className="seeMoreLuckHeading_multireplayer">
                            <div style={{ marginLeft: "15px" }}>All hands in Session&nbsp;
                            </div>
                            <i className="fa fa-times modalCloseButton modalCloseButton_MultiReplayer" onClick={this.props.onCloseViewAllHands}></i>
                        </div>
                        {this.props.handList &&
                            <div className="topWonNLossLandPage">
                                <table style={{ width: '100%' }}>
                                    <thead className="">
                                        <tr className="">
                                            <th className={`topWonLossCardHeading_multireplayer luckModalTh_MultiReplayer ${this.props.handList.length > 5 ? " Padding_left_SingleRowPlus" : "Padding_left_SingleRow"}`}>Cards</th>
                                            <th className='topWonLossFlopHeading_multireplayer luckModalTh_MultiReplayer'>Flop</th>
                                            <th className='topWonLossTurnHeading_multireplayer luckModalTh_MultiReplayer'>Turn</th>
                                            <th className='topWonLossRiver_multireplayer luckModalTh_MultiReplayer'>River</th>
                                            <th className='topWonLossProfitHeading_multireplayer luckModalTh_MultiReplayer'>Profit</th>
                                            <th className='topWonLossStar_multireplayer luckModalTh_MultiReplayer'></th>
                                            <th className='topWonLossPlay_multireplayer luckModalTh_MultiReplayer Padding_right_SingleRow'></th>
                                        </tr>
                                    </thead>
                                </table>
                                <div className="topWonNLossLandPage_multiReplayer">
                                    <table style={{ width: '100%' }}>
                                        <tbody>
                                            {this.props.handList.map((hand, i) =>
                                                <HandListSingleRow key={i} hand={hand}
                                                    showStarOption={this.props.showStarOption}
                                                    indexOfHand={i}
                                                    openThisHand={this.props.openThisHand}
                                                    setStarFlagOfHnad={this.props.setStarFlagOfHnad}
                                                    currentReplayerHandIndex={this.props.currentReplayerHandIndex}
                                                    handReplayerOpen={() => {
                                                        this.props.openThisHand(i);
                                                    }}
                                                />)}
                                        </tbody>
                                    </table>
                                </div>
                            </div>}
                    </div>
                </div>
            </div >
        )
    }
}

export default AllSelectedHandList;


/** WEBPACK FOOTER **
 ** ./src/components/HandHistory/AllSelectedHandList.js
 **/